// src/components/PageHeader.js
// En-tête de page réutilisable : titre + frise de vagues (identité visuelle commune).
import React from "react";
import "./PageHeader.css";

export default function PageHeader({ title, subtitle, action }) {
    return (
        <>
            <div className="page-header">
                <h1>{title}</h1>
                {action}
            </div>
            {subtitle && <div className="page-header-sub">{subtitle}</div>}
            <svg className="page-wave" viewBox="0 0 1200 26" preserveAspectRatio="none" aria-hidden="true">
                <path className="page-wave-back" d="M-140,14 C10,26 160,2 310,14 C460,26 610,2 760,14 C910,26 1060,2 1210,14 C1280,20 1320,10 1340,12 L1340,26 L-140,26 Z" fill="var(--blue-accent)" opacity="0.28" />
                <path className="page-wave-front" d="M-140,18 C10,8 160,28 310,18 C460,8 610,28 760,18 C910,8 1060,28 1210,18 C1280,12 1320,22 1340,18 L1340,26 L-140,26 Z" fill="var(--primary-blue)" opacity="0.85" />
            </svg>
        </>
    );
}
